module.exports = __webpack_public_path__ + "img/metal_aa@2x.cca309f9.png";